import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './AppealScreen.css';
import api from '../api';

function AppealScreen() {
  const navigate = useNavigate();
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [successMsg, setSuccessMsg] = useState('');

  const storedUser = JSON.parse(localStorage.getItem('barterfi_user'));
  const { username, userType } = storedUser || {};

  useEffect(() => {
    if (successMsg || errorMsg) {
      const timer = setTimeout(() => {
        setSuccessMsg('');
        setErrorMsg('');
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [successMsg, errorMsg]);



const handleSubmit = async () => {
  if (!message.trim()) {
    setErrorMsg('Please write a message for your appeal.');
    return;
  }

  try {
    setLoading(true);
    setErrorMsg('');
    setSuccessMsg('');

    await api.post('/appeals', {
      username,
      role: userType === 'merchant' ? 'merchant' : 'pioneer',
      message
    });

    setSuccessMsg(' Appeal submitted successfully!');
    setMessage('');
    setTimeout(() => navigate(-1), 2000);
  } catch (err) {
    console.error('❌ Failed to submit appeal:', err);

    if (err?.response?.status === 409) {
      setErrorMsg(' You have already submitted an appeal. Please wait for admin review before submitting another.');
    } else {
      setErrorMsg('Something went wrong. Please try again later.');
    }
  } finally {
    setLoading(false);
  }
};


  return (
    <div className="appeal-screen">
      {/* ✅ Toast notifications */}
      {successMsg && <div className="toast success show">{successMsg}</div>}
      {errorMsg && <div className="toast error show">{errorMsg}</div>}

      <h2>Appeal Your Suspension</h2>
      <p>If you believe your suspension was a mistake, please explain below:</p>

      <textarea
        placeholder="Write your appeal..."
        rows={6}
        value={message}
        onChange={(e) => setMessage(e.target.value)}
      />

      <div className="appeal-buttons">
        <button className="submit-btn" onClick={handleSubmit} disabled={loading}>
          {loading ? 'Submitting...' : 'Submit Appeal'}
        </button>
        <button className="cancel-appeal-btn" onClick={() => navigate(-1)}>Cancel</button>
      </div>
    </div>
  );
}

export default AppealScreen;
